﻿import React, { useState, useEffect } from 'react';
import { CalculatorStandardComponent } from '../models/Calculators/calculator-standard-component';
import { CalculatorStandard } from '../models/Calculators/calculator-standard';
import { CrudFunctions } from '../utilities/crud-functions';
import { ModalMetadata } from '../models/modal-metadata';
import { EditType, ModalMessageType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';
import { DataTemplates } from '../templates/data-templates';

import DataGrid, {
    Column,
    Selection,
    Editing,
    Paging,
    Toolbar,
    HeaderFilter,
    FilterRow,
    Item as ToolBarItem,
    LoadPanel
} from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';

export interface Props {
    calculatorId: string;
    catalogNumber: string;
    batchName: string;
    onClose?: () => void;
}

export default function CalculatorComponents(props: Props) {
    const [components, setComponents] =
        useState<CalculatorStandardComponent[]>();

    const [calculatorStandards, setCalculatorStandards] =
        useState<CalculatorStandard[]>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getAllData();
    }, [props.calculatorId]);

    let showRefStandard1Column = false;
    let showRefStandard2Column = false;
    let showRefStandard3Column = false;
    let refStandard1ColumnHeader = "";
    let refStandard2ColumnHeader = "";
    let refStandard3ColumnHeader = "";

    if (calculatorStandards && calculatorStandards.length > 0) {
        refStandard1ColumnHeader = `${calculatorStandards[0].catalogNumber}\n${calculatorStandards[0].lotNumber}\nConcentration`;
        showRefStandard1Column = true;
    }

    if (calculatorStandards && calculatorStandards.length > 1) {
        refStandard2ColumnHeader = `${calculatorStandards[1].catalogNumber}\n${calculatorStandards[1].lotNumber}\nConcentration`;
        showRefStandard2Column = true;
    }

    if (calculatorStandards && calculatorStandards.length > 2) {
        refStandard3ColumnHeader = `${calculatorStandards[2].catalogNumber}\n${calculatorStandards[2].lotNumber}\nConcentration`;
        showRefStandard3Column = true;
    }

    return (
        <div>
            <div className="pw-comp-row pw-margin-top-05">
                <div className="title-bar-spacer" />
                <div className="save-toolbar pw-margin-right-05">

                    <Button id="saveButton" text="Save" icon="save" type="success"
                        className="pw-button"
                        hint="save changes"
                        height={'1.8rem'}
                        onClick={onSaveClick} />

                    <Button id="closeButton" text="Close" icon="close" type="normal"
                        className="pw-button"
                        hint="close dialog"
                        height={'1.8rem'}
                        onClick={onCloseClick} />
                </div>
            </div>

            <div className="pw-comp-row">
                <div className="pw-form-unit lq-header-3">MS Samples</div>
            </div>

            <div className="pw-comp-row">
                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Catalog Number</div>
                    <div className="pw-readonly-label">{props.catalogNumber}</div>
                </div>

                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Batch Name</div>
                    <div className="pw-readonly-label">{props.batchName}</div>
                </div>
            </div>

            {calculatorStandards && calculatorStandards.length > 0 && calculatorStandards.map((standard) =>
                <div key={standard.calculatorStandardId}>
                    <div className="pw-comp-row">
                        <div className="pw-form-unit lq-header-3">{standard.catalogNumber} - {standard.lotNumber}</div>
                    </div>

                    <div className="pw-comp-row" key={standard.calculatorStandardId.toString()}>
                        <div className="pw-form-unit pw-comp-20">
                            <div className="pw-form-unit-label">Standards Manufacturer</div>
                            <div className="pw-readonly-label">{standard.standardManufacturer &&
                                standard.standardManufacturer.description ?
                                standard.standardManufacturer.description : 'NA'}</div>
                             </div>

                        <div className="pw-form-unit">
                            <div className="pw-form-unit-label">Standard Catalog#</div>
                            <div className="pw-readonly-label">{standard.catalogNumber ?
                                standard.catalogNumber : 'NA'}</div>
                        </div>

                        <div className="pw-form-unit">
                            <div className="pw-form-unit-label">Standard Lot#</div>
                            <div className="pw-readonly-label">{standard.lotNumber ?
                                standard.lotNumber : 'NA'}</div>
                        </div>
                    </div>
                </div>
            )}

            <div>
                <DataGrid
                    width="100%"
                    height="26rem"
                    keyExpr="componentId"
                    dataSource={components ? components : []}
                    onSelectionChanged={onComponentSelectionChanged}
                    onRowValidating={onComponentSelectionValidating}
                    rowAlternationEnabled={true}
                    wordWrapEnabled={true}
                    showRowLines={true}
                    showBorders={true} >

                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />
                    <LoadPanel enabled={false} />

                    <Selection mode='single' />
                    <Paging enabled={false} />

                    <Column width='2rem' cssClass="table-vertical-align"
                        cellRender={DataTemplates.EditMarkerCellRender} />

                    <Column dataField='componentName' dataType="string"
                        allowEditing={false}
                        width='20rem' cssClass="table-vertical-align" />
                                           
                    <Column dataField='lotNumber' dataType="string"
                        allowEditing={false}
                        width='10rem' cssClass="table-vertical-align" />

                    <Column dataField='concentration' dataType="number"
                        caption="MS Sample Concentration"
                        width='10rem' cssClass="table-vertical-align" />

                    {showRefStandard1Column &&
                        <Column dataField='refStandard1Concentration' dataType="number"
                            caption={refStandard1ColumnHeader}
                            width='10rem' cssClass="table-vertical-align" />
                    }

                    {showRefStandard2Column &&
                        <Column dataField='refStandard2Concentration' dataType="number"
                            caption={refStandard2ColumnHeader}
                            width='10rem' cssClass="table-vertical-align" />
                    }

                    {showRefStandard3Column &&
                        <Column dataField='refStandard3Concentration' dataType="number"
                            caption={refStandard3ColumnHeader}
                            width='10rem' cssClass="table-vertical-align" />
                    }

                    <Column />

                    <Editing mode="cell"
                        useIcons={true}
                        allowAdding={false}
                        allowUpdating={true}
                        allowDeleting={false} />

                    <Toolbar>
                        <ToolBarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Components</div>
                            </div>
                        </ToolBarItem>
                    </Toolbar>
                </DataGrid>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    async function onSaveClick() {
        console.log("onSaveClick, components:");
        console.log(components);

        await updateCalculatorStandardComponents(components)
            .then((data) => {
                console.log(data);

                getAllData();
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Updating Components");
            })
    }

    function onCloseClick() {
        if (props.onClose)
            props.onClose();
    }

    function onComponentSelectionChanged(e: any) {


    }

    function onComponentSelectionValidating(e: any) {
        e.newData.editType = EditType.Update;
    }

    async function getCalculatorComponents() {
        await CrudFunctions.getData(`calculator/calculatorstandardcomponents/${props.calculatorId}`)
            .then((data) => {
                console.log("comps:");
                console.log(data);

                setComponents(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Components");
            })
    }

    async function getCalculatorStandards() {
        await CrudFunctions.getData(`calculator/calculatorstandards/${props.calculatorId}`)
            .then((data) => {
                console.log("standards:");
                console.log(data);

                setCalculatorStandards(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Current Agilent Raw Data");
            })
    }

    async function updateCalculatorStandardComponents(components: CalculatorStandardComponent[]) {
        return await CrudFunctions.putData(`calculator/calculatorstandardcomponents/${props.calculatorId}`, components);
    }    

    async function getAllData() {
        await Promise.all([
            getCalculatorComponents(),
            getCalculatorStandards()
        ]);
    }
      
    //other

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}